import store from "../state/store"
import {
    logoutAction,
    updateAuth,
    updateAlert,
    refetchingToken,
    updateUpdatingToken,
    updateSettimeoutObject,
} from "../state/login/loginSlice"
import { navigate } from "gatsby"
import {
    healthInstance,
    journalInstance,
    authInstance,
    lambdaInstance,
    chatGPTInstance,
    gptInstance,
    twilioInstance,
    carePlanAiInstance,
    DoctoriteAiInstance,
    docAssistInstance,
} from "./axios"
import queryString from "query-string"
import { authTokenURL } from "../apiEndPoints"
import { endLoginTimeTracker } from "../state"
import { userLoggedOut } from "../state/rootReducer"
import axios from "axios"

let isRefreshing = false
let prevRefreshToken = ""
const refreshAndRetryQueue = []
const ongoingRequests = new Map()
const MAX_RETRIES = 3
const generateRequestId = config => {
    return (
        config.method.toUpperCase() +
        config.url +
        JSON.stringify(config.params || {}) +
        JSON.stringify(config.data || {})
    )
}
const onRequest = async config => {
    // const requestId = generateRequestId(config);

    // if (ongoingRequests.has(requestId)) {
    //     console.log('Duplicate request intercepted and cancelled:', config);
    //     return Promise.reject(new Error('Duplicate request intercepted and cancelled'));
    // }

    // ongoingRequests.set(requestId, true);
    if (isRefreshing) {
        await new Promise(resolve => setTimeout(resolve, 3000))
    }
    const token = JSON.parse(localStorage.getItem("userAuth"))
    if (
        token &&
        token.hasOwnProperty("access_token") &&
        token.access_token !== ""
    ) {
        config.headers["userType"] = "patient"
        config.headers["Authorization"] = token.access_token
    }
    return config
}

const onRequestError = error => {
    return Promise.reject(error)
}

const onResponse = response => {
    // const requestId = generateRequestId(response.config);
    // ongoingRequests.delete(requestId);
    return response
}

const onResponseError = async error => {
    console.log(error, "error in response error")
    // const requestId = generateRequestId(error.config);
    // ongoingRequests.delete(requestId);
    const originalRequest = error.config

    // Check if it's the first retry attempt and not already retried
    if (originalRequest && !originalRequest._retry) {
        originalRequest._retry = true
        originalRequest._retryCount = 1
    }

    // Retry the request if we have not exceeded MAX_RETRIES
    if (
        originalRequest &&
        originalRequest._retryCount < MAX_RETRIES &&
        error.response
    ) {
        originalRequest._retryCount += 1
        console.log(
            `Retrying request (${originalRequest._retryCount}/${MAX_RETRIES})`
        )

        // Wait for some delay before retrying (optional)
        await new Promise(resolve => setTimeout(resolve, 500))

        // Retry the request
        switch (
            originalRequest.baseURL
                .split("https://")[0]
                .split(".")[0]
                .split("-")[0]
        ) {
            case "health": {
                healthInstance(originalRequest)
                break
            }
            case "journal": {
                journalInstance(originalRequest)
                break
            }
            case "auth": {
                authInstance(originalRequest)
                break
            }
        }
    }

    // If retries exceeded or other errors, reject the promise
    // return Promise.reject(error);
    console.log("check if it comes here", error, originalRequest.baseUrl)
    if (error.response?.status === 401) {
        localStorage.removeItem("userAuth")
        store.dispatch(endLoginTimeTracker(false))
        store.dispatch(logoutAction())
        store.dispatch(userLoggedOut())
        navigate("/login")
        store.dispatch(
            updateAlert({
                ...store.getState().login.alert,
                open: true,
                type: "error",
                msg: `Token expired please login again`,
            })
        )
        return null
    }
    // if (error.response?.status === 401 ) {
    //     if (!isRefreshing) {
    //         isRefreshing = true;
    //         try {
    //         // Refresh the access token
    //         const newAccessToken = await refreshToken()

    //         // Update the request headers with the new access token
    //         // error.config.headers['Authorization'] = `Bearer ${newAccessToken}`;

    //         // Retry all requests in the queue with the new token
    //         if(newAccessToken) {
    //             refreshAndRetryQueue.forEach(({ config, resolve, reject }) => {
    //                 switch(config.baseURL.split('.')[0].split('://')[1].split('-')[0]) {
    //                     case 'health':
    //                         healthInstance.request(config)
    //                             .then((response) => resolve(response))
    //                             .catch((err) => reject(err));
    //                         break;
    //                     case 'journal':
    //                         journalInstance.request(config)
    //                             .then((response) => resolve(response))
    //                             .catch((err) => reject(err));
    //                         break;
    //                     default:
    //                         break;
    //                 }
    //             });

    //             // Clear the queue
    //             refreshAndRetryQueue.length = 0;

    //             // Retry the original request
    //             switch(originalRequest.baseURL.split('.')[0].split('://')[1].split('-')[0]) {
    //                     case 'health':
    //                         healthInstance(originalRequest)
    //                         break;
    //                     case 'journal':
    //                         journalInstance(originalRequest)
    //                         break;
    //                     default:
    //                         break;
    //                 }
    //         }
    //         } catch (refreshError) {
    //         // Handle token refresh error
    //         // You can clear all storage and redirect the user to the login page
    //         throw refreshError;
    //         } finally {
    //         isRefreshing = false;
    //         }
    //     }
    //     return new Promise((resolve, reject) => {
    //         refreshAndRetryQueue.push({ config: originalRequest, resolve, reject });
    //     });
    // }
    return Promise.reject(error)
    // if(isRefreshing) {
    //     const delayRetryRequest = new Promise((resolve) => {
    //         setTimeout(() => {
    //         resolve();
    //         }, 15000);
    //     });
    //     return delayRetryRequest.then(() => axios(error.config));
    // }
    // if(!store.getState().login.refetchingToken) {
    //     store.dispatch(refetchingToken(true))
    //     const refreshTokenStatus = await refreshToken()
    //     store.dispatch(refetchingToken(false))
    //     console.log("refreshtoken status", refreshTokenStatus)
    //     if(refreshTokenStatus?.data?.responseData) axios(error.config)
    // }
    // }
}

healthInstance.interceptors.request.use(onRequest, onRequestError)
healthInstance.interceptors.response.use(onResponse, onResponseError)

journalInstance.interceptors.request.use(onRequest, onRequestError)
journalInstance.interceptors.response.use(onResponse, onResponseError)

docAssistInstance.interceptors.request.use(onRequest, onRequestError)
docAssistInstance.interceptors.response.use(onResponse, onResponseError)

authInstance.interceptors.request.use(
    async config => {
        if (!config.headers["Authorization"]) {
            config.headers["Authorization"] = `Basic ${
                store.getState().key.authToken
            }`
        }
        config.headers["UserType"] = "patient"
        config.headers["Content-Type"] = "application/x-www-form-urlencoded"
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

export const refreshToken = async (success = () => {}) => {
    let auth = JSON.parse(localStorage.getItem("userAuth"))
    let refresh_token =
        auth &&
        auth.hasOwnProperty("refresh_token") &&
        auth.refresh_token !== ""
            ? auth.refresh_token
            : ""
    let data = {
        grant_type: "refresh_token",
        refresh_token: refresh_token,
    }
    if (!data?.refresh_token || prevRefreshToken === data?.refresh_token) {
        return
    }
    prevRefreshToken = data?.refresh_token
    isRefreshing = true
    try {
        isRefreshing = true
        const resp = await authInstance.post(
            authTokenURL,
            queryString.stringify(data)
        )
        console.log("refresh token console log", resp.data)
        store.dispatch(updateAuth(resp.data))
        localStorage.setItem("userAuth", JSON.stringify(resp.data))
        const check = store.getState().login.settimeoutObject
        if (check) {
            try {
                clearTimeout(check)
            } catch (e) {}
        }
        const temp = setTimeout(() => {
            refreshToken()
        }, (resp.data.expires_in - 10) * 1000)
        store.dispatch(updateSettimeoutObject(temp))
        success()
        isRefreshing = false
        return resp.data
    } catch (e) {
        // if(e.response?.data?.error === "invalid_grant" || e.response?.data?.error === "invalid_token" || !e.response) {
        localStorage.removeItem("userAuth")
        store.dispatch(endLoginTimeTracker(false))
        store.dispatch(logoutAction())
        store.dispatch(userLoggedOut())
        navigate("/login")
        store.dispatch(
            updateAlert({
                ...store.getState().login.alert,
                open: true,
                type: "error",
                msg: `Token expired please login again`,
            })
        )
        isRefreshing = false
        return null
        // }
    }
}

export const generateToken = async (data, userType, success, failure) => {
    try {
        const formData = new FormData()
        formData.append("grant_type", data.grant_type)
        formData.append("username", data.username)
        formData.append("password", data.password)
        formData.append("dateOfBirth", data.dateOfBirth)
        const resp = await authInstance.post(authTokenURL, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                UserType: "patient",
                LoginType: "Phone",
                Authorization: "Basic ZG9jdG9yLWFwcDpkb2N0b3Jfc2VjcmV0X2tleQ==",
                "Content-Type": "application/x-www-form-urlencoded",
            },
        })
        store.dispatch(updateAuth(resp.data))
        localStorage.setItem("userAuth", JSON.stringify(resp.data))
        const temp = setTimeout(() => {
            refreshToken()
        }, Math.max(0, resp.data.expires_in - 10) * 1000)
        store.dispatch(updateSettimeoutObject(temp))
        success()
    } catch (e) {
        alert("Login failed", e.message)
        console.log("Error", e)
        failure()
    }
}

// healthInstance.interceptors.response.use(
//     async function (response) {
// console.log("<---- RESPONSE ---->", response);
// const originalRequest = response.config;
// if (response?.data?.data?.error && response.data.data.error === "Invalid Token" && !originalRequest._retry) {
//     originalRequest._retry = true;
//     const resp = await refreshToken();
//     console.log("Referesh Token Response", resp);
//     let auth = store.getState().login.auth;
//     if (auth !== undefined && auth !== null) {
//         const access_token = auth.access_token;
//         healthInstance.defaults.headers.common[
//             "Authorization"
//         ] = `${access_token}`;
//         return healthInstance(originalRequest);
//     }
//     else {
//         handleTokenRefresh();
//     }
// }
//         return Promise.resolve(response);
//     },
//     async function (error) {
//         console.log("<---- ERROR ---->", error)
//         return Promise.reject(error);
//     }
// );

// journalInstance.interceptors.response.use(
//     async function (response) {
//         console.log("<---- RESPONSE ---->", response);
//         const originalRequest = response.config;
//         if (response?.data?.data?.error && response.data.data.error === "Invalid Token" && !originalRequest._retry) {
//             originalRequest._retry = true;

//             const resp = await refreshToken();
//             console.log("Referesh Token Response", resp);
//             let auth = store.getState().login.auth;
//             if (auth !== undefined && auth !== null) {
//                 const access_token = auth.access_token;

//                 journalInstance.defaults.headers.common[
//                     "Authorization"
//                 ] = `${access_token}`;
//                 return journalInstance(originalRequest);
//             }
//             else {
//                 handleTokenRefresh();
//             }
//         }
//         return Promise.resolve(response);
//     },
//     async function (error) {
//         return Promise.reject(error);
//     }
// );

// docAssistInstance.interceptors.response.use(
//     async function (response) {
//         console.log("<---- RESPONSE ---->", response);
//         const originalRequest = response.config;
//         if (response?.data?.data?.error && response.data.data.error === "Invalid Token" && !originalRequest._retry) {
//             originalRequest._retry = true;

//             const resp = await refreshToken();
//             console.log("Referesh Token Response", resp);
//             let auth = store.getState().login.auth;
//             if (auth !== undefined && auth !== null) {
//                 const access_token = auth.access_token;

//                 journalInstance.defaults.headers.common[
//                     "Authorization"
//                 ] = `${access_token}`;
//                 return journalInstance(originalRequest);
//             }
//             else {
//                 handleTokenRefresh();
//             }
//         }
//         return Promise.resolve(response);
//     },
//     async function (error) {
//         return Promise.reject(error);
//     }
// );

lambdaInstance.interceptors.response.use(
    async function (response) {
        console.log("<---- RESPONSE ---->", response)
        return Promise.resolve(response)
    },
    async function (error) {
        console.log("<---- ERROR ---->", error)
        return Promise.reject(error)
    }
)

chatGPTInstance.interceptors.response.use(
    async function (response) {
        console.log("<---- RESPONSE ---->", response)
        return Promise.resolve(response)
    },
    async function (error) {
        console.log("<---- ERROR ---->", error)
        return Promise.reject(error)
    }
)

gptInstance.interceptors.response.use(
    async function (response) {
        console.log("<---- RESPONSE ---->", response)
        return Promise.resolve(response)
    },
    async function (error) {
        console.log("<---- ERROR ---->", error)
        return Promise.reject(error)
    }
)

twilioInstance.interceptors.response.use(
    async function (response) {
        console.log("<---- RESPONSE ---->", response)
        return Promise.resolve(response)
    },
    async function (error) {
        console.log("<---- ERROR ---->", error)
        return Promise.reject(error)
    }
)

carePlanAiInstance.interceptors.response.use(
    async function (response) {
        console.log("<----CARE PLAN AI RESPONSE ---->", response)
        return Promise.resolve(response)
    },
    async function (error) {
        console.log("<----CARE PLAN AI ERROR ---->", error)
        return Promise.reject(error)
    }
)

export async function axiosGet(
    url = "",
    headers = {},
    queryParams = {},
    body = {},
    responseType
) {
    if (Object.entries(queryParams).length) {
        url += "?"
        let entries = Object.entries(queryParams)
        for (let param of entries) url += `${param[0]}=${param[1]}&`
    }
    try {
        const response = await healthInstance({
            method: "GET",
            url: url,
            ...(responseType ? { responseType } : {}),
            headers: {
                ...headers,
            },
            body: body,
        })
        console.log(response)
        return response
    } catch (err) {
        console.log(err, "axios get error")
    }
}

export async function axiosPost(url = "", data = {}, headers = {}) {
    try {
        return await healthInstance({
            method: "POST",
            url: url,
            data: data,
            headers: {
                ...headers,
            },
        })
    } catch (err) {
        console.log(err, "axios post error")
    }
}

export async function axiosDocAssistPost(url = "", data = {}, headers = {}) {
    try {
        return await docAssistInstance({
            method: "POST",
            url: url,
            data: data,
            headers: {
                ...headers,
            },
        })
    } catch (err) {
        console.log(err, "axios post error")
    }
}

export function axiosPut(url = "", data = {}, headers = {}) {
    return healthInstance({
        method: "PUT",
        url: url,
        data: data,
        headers: {
            ...headers,
        },
    })
}

export function axiosDelete(url = "", headers = {}) {
    return healthInstance({
        method: "DELETE",
        url: url,
        headers: {
            ...headers,
        },
    })
}

export function axiosPatch(url = "", data = {}, headers = {}) {
    return healthInstance({
        method: "PATCH",
        url: url,
        data: data,
        headers: {
            ...headers,
        },
    })
}

export function axiosGetJournal(url = "", headers = {}) {
    return journalInstance({
        method: "GET",
        url: url,
        headers: {
            ...headers,
        },
    })
}

export function axiosPostJournal(url = "", data = {}, headers = {}) {
    return journalInstance({
        method: "POST",
        url: url,
        data: data,
        headers: {
            ...headers,
        },
    })
}

export function axiosPutJournal(url = "", data = {}, headers = {}) {
    return journalInstance({
        method: "PUT",
        url: url,
        data: data,
        headers: {
            ...headers,
        },
    })
}

export function axiosDeleteJournal(url = "", headers = {}) {
    return journalInstance({
        method: "DELETE",
        url: url,
        headers: {
            ...headers,
        },
    })
}

export function axiosPatchJournal(url = "", data = {}, headers = {}) {
    return journalInstance({
        method: "PATCH",
        url: url,
        data: data,
        headers: {
            ...headers,
        },
    })
}

export function axiosLambdaGet(url = "", headers = {}) {
    console.log("url", url)
    return lambdaInstance({
        method: "GET",
        url: url,
        headers: {
            ...headers,
        },
    })
}

export function axiosGetChatGPT(url = "", headers = {}) {
    console.log("url", url)
    return chatGPTInstance({
        method: "GET",
        url: url,
        headers: {
            ...headers,
        },
    })
}

export function axiosPostChatGPT(url = "", data = {}, headers = {}) {
    return chatGPTInstance({
        method: "POST",
        url: url,
        data: data,
        headers: {
            ...headers,
        },
    })
}

export function axiosGetGPT(url = "", headers = {}) {
    console.log("url", url)
    return gptInstance({
        method: "GET",
        url: url,
        headers: {
            ...headers,
        },
    })
}

export function axiosPostGPT(url = "", data = {}, headers = {}) {
    return gptInstance({
        method: "POST",
        url: url,
        data: data,
        headers: {
            ...headers,
        },
    })
}

export function axiosGetTwilio(url = "", headers = {}) {
    console.log("url", url)
    return twilioInstance({
        method: "GET",
        url: url,
        headers: {
            ...headers,
        },
    })
}

export function axiosPostCarePlanAI(url = "", data = {}, headers = {}) {
    console.log("url", url)
    return carePlanAiInstance({
        method: "POST",
        url: url,
        data: data,
        headers: {
            ...headers,
        },
    })
}

export function axiosDoctoriteAiInstance(
    method = "GET",
    url = "",
    data = {},
    headers = {}
) {
    console.log(url, "url in doc ai instance")
    return DoctoriteAiInstance({
        method: method,
        url: url,
        data: data,
        headers: {
            ...headers,
        },
    })
}

const handleTokenRefresh = () => {
    console.log("<---- REFESH TOKEN ---->")
    // store.dispatch(endLoginTimeTracker(false))
    // store.dispatch(logoutAction())
    // store.dispatch(userLoggedOut())
    sessionStorage.removeItem("patientComponentState")
    localStorage.setItem("user", JSON.stringify({}))
    navigate("/login")
}
